import script from "./Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Popup.vue?vue&type=script&setup=true&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=a545ab0a&lang=scss"

const __exports__ = script;

export default __exports__